<template>
    <div class="papsi-wrapper flex justify-between">
        <div class="flex max-sm:flex-col max-sm:gap-3 justify-between w-full">
            <div>
                <h1 class="text-xl font-semibold text-[#24723b]" v-text="'Training Requisition Requests'"/>
                <p class="text-xs text-[#747474] mt-2" v-text="'Home / Form Requests / Training Requisition Requests'"/>
            </div>
            <div class="flex gap-3">
                <!-- <ButtonComponent 
                    class="w-[200px]"
                    :enabled="button"
                    :name="'REQUEST STATUS'"
                    @click="obRequest"
                />
                <ButtonComponent 
                    class="w-[200px]"
                    :enabled="!button"
                    :name="'NOTED REQUEST'"
                    @click="notedRequest"
                /> -->
            </div>
        </div>
    </div>
    <div class="mt-6 w-full h-full flex flex-col gap-3">
        <div class="flex gap-3">
            <TextboxComponent 
                v-if="button"
                v-model="search"
                @input="searchByName()" 
                :labelname="'Search'" 
                class="w-[500px]"/>
            <ComboBoxComponent
                v-if="button"
                v-model="filter" 
                :labelname="'Filter'" 
                class="w-[250px]" 
                :data="combobox"
                @change="searchByName()"/>
        </div>
        
        <div class="h-[73vh]">
            <TableComponent 
                :header="header_name" 
                :column="column_name" 
                :data="trn_filter" 
                :viewBtn="true"
                :select="false"
                @clickView="openTrModal" />
        </div>
    </div>

    <!-- PROMPT SUCCESSS ERROR -->
    <PromptComponent v-if="promptModal"
        :header="header"
        :header1="header1"
        :success="promptSuccess"
        @close="promptModal = false"/>

    <!-- VALIDATION PROMPT -->
    <ValidationComponent v-if="validation"
        :header="headerPrompt"
        @yes="approveRequest"
        @no="noValidation"/>

    <!-- MODAL -->
    <TrainingModal v-if="trainingModal"
        @close="trainingModal = false"
        @cancel="cancelValidation"
        @approve="approveValidationPrompt"
        @viewpdf="viewPdf"
        :data="modal_data"
        :apv="true"
        :cancel="false"/>

</template>
<script>
    import { defineComponent } from "vue";
    import Training from "@/services/training";
    import TextboxComponent from "@/v1/components/TextBoxComponent/TextboxComponent.vue";
    import TableComponent from "@/v1/components/TableComponent/TableComponent.vue";
    import PromptComponent from "@/v1/components/PromptComponents/PromptComponent.vue";
    import ValidationComponent from "@/v1/components/PromptComponents/ValidationComponent.vue";
    //import ButtonComponent from "@/v1/components/ButtonComponent/ButtonComponent.vue";
    import ComboBoxComponent from "@/v1/components/ComboBoxComponent/ComboBoxComponent.vue";
    import TrainingModal from "@/v1/modal/TrainingModal.vue";

    export default defineComponent({
    components: {
        PromptComponent,
        ValidationComponent,
        TableComponent,
       // ButtonComponent,
        ComboBoxComponent,
        TextboxComponent,
        TrainingModal
    },
    data() {
        return {
            combobox:[
                { key: "ALL", value: "ALL" },
                { key: "FOR RECOMMENDATION", value: "FOR RECOMMENDATION" },
                { key: "FOR APPROVAL", value: "FOR APPROVAL" },
                { key: "PROCESSED BY (OHR)", value: "PROCESSED BY (OHR)" },
                { key: "RECOMMENDED FOR APPROVAL (OHR)", value: "RECOMMENDED FOR APPROVAL (OHR)" },
                { key: "APPROVED BY (OHR)", value: "APPROVED BY (OHR)" },
                { key: "DISAPPROVED", value: "DISAPPROVED" },
                { key: "APPROVED", value: "APPROVED" },
                { key: "CANCELLED", value: "CANCELLED" },
            ],
            header_name:  [
                "Reference No.",
                "Employee Name",
                "Date Submitted",
                "Training Category" ,
                "Status",
                "Action",
            ],
            column_name:  [ 
                "ref_no",
                "employee_name",
                "date_submitted",
                "training_category",
                "status",
                "action"
            ],
            button: true,
            trn_data:[],
            trn_filter:[],
            search: '',
            filter: "ALL",
            trainingModal:false,
            modal_data: null,
            promptModal: false,
            header:null,
            header1:null,
            promptSuccess:true,
            type : null,
            headerPrompt: null,
            validation:false,
            ref_no:null,
            status_request: null,
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        // obRequest(){
        //     this.button = true
        //     this.getData()
        // },
        // notedRequest(){
        //     this.button = false
        //     this.filterNotedRequest()
        // },
        // filterNotedRequest(){
        //     this.ob_filter = this.ob_data.filter(e =>e.employee_name.toLowerCase().includes(this.search.toLowerCase()) && e.status === "APPROVED" && e.noted_emp_key === null)
        // },
        // triggerbtn(){
        //     this.button = !this.button ? true : false
        // },
        noValidation(){
            this.ref_no     = null
            this.validation = false
        },
        async viewPdf(ref_no){
            this.$emit("showLoader")
        
            await Training.trainingPdf(ref_no).then(function(response){
                const newTab = window.open('', '_blank');
                const base64 = response.data.data;
                const pdfDataUrl = `data:application/pdf;base64,${base64}`;
                    newTab.document.open();
                    newTab.document.write(`
                        <!DOCTYPE html>
                        <html>
                        <head>
                            <title>Training Requisition PDFs</title>
                            <style>
                                html, body {
                                    margin: 0;
                                    padding: 0;
                                    height: 100%;
                                }
                                iframe {
                                    width: 100%;
                                    height: 100%;
                                    border: none;
                                }
                            </style>
                        </head>
                        <body>
                            <iframe src="${pdfDataUrl}"></iframe>
                        </body>
                        </html>
                    `);
                    newTab.document.close();
            })
            this.$emit("hideLoader")
        },
        async getData(){
            this.$emit("showLoader")
            let that = this
            await Training.getRequest().then(function(response){
                that.trn_data = response.data.data
                that.trn_filter = response.data.data
            })
            this.$emit("hideLoader")
        },
        searchByName(){
            if(this.button){
                 if(this.filter == "ALL")
                    this.trn_filter = this.search ? this.trn_data.filter(e =>e.employee_name.toLowerCase().includes(this.search.toLowerCase())) : this.trn_data
            else
                this.trn_filter =  this.filter? this.trn_data.filter(e =>e.employee_name.toLowerCase().includes(this.search.toLowerCase()) && e.status === this.filter) : this.trn_data
            }
        },
        openTrModal(data){
            this.modal_data     = data
            this.trainingModal  = true
        },
        approveValidationPrompt(ref_no, status){
            this.status_request = status
            this.ref_no         = ref_no
            this.headerPrompt   = "Are you sure you want to approve this request?"
            this.approved       = true
            this.validation     = true
        },
        async approveRequest(){
            //let that = this
            let type = null, next = null, that = this;

            const map = {
                "PROCESSED BY (OHR)": "PB",
                "RECOMMENDED FOR APPROVAL (OHR)": "RB",
                "APPROVED BY (OHR)": "AB"
            };

            const nextStatusMap = {
                "PB": "RECOMMENDED FOR APPROVAL (OHR)",
                "RB": "APPROVED BY (OHR)",
                "AB": "APPROVED",
            };

            type = map[this.status_request] ?? null;
            next = nextStatusMap[type] ?? null;

            this.$emit("showLoader")
            await Training.approveRequest(this.ref_no, type).then(function(){
                that.trainingModal      = false
                that.validation         = false
                that.promptSuccess      = true
                that.header             = "SUCCESS"
                that.header1            = "The training request has been reviewed and approved successfully."
                that.promptModal        = true
                that.updateRequest(that.ref_no, next)
            })
            this.$emit("hideLoader")
            
        },
        updateRequest(ref_no, status)
        {
            const record = this.trn_data.find(e => e.ref_no === ref_no);
            if (record) {
                record.status = status;
            }
            this.searchByName()
        }
    }
})

</script>

